import './loader.style.sass';
import template from './loader.tpl.pug';

export default {
    selector: 'dbLoader',
    template: template(),
    transclude: true,
    bindings: {
        visible: '<',
        overlay: '<',
        fit: '<'
    }
};



// WEBPACK FOOTER //
// ./src/common/component/loader/loader.cmpt.js